export default __webpack_public_path__ + "static/media/rakhi1.ac3ba11f.jpeg";